import { Component, effect, HostListener, inject, OnDestroy, OnInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthService } from '@core/services/auth.service';
import { CoreDropButtonComponent } from '@shared/custom-components/core-drop-button/core-drop-button.component';
import { CoreButtonComponent } from '@shared/custom-components/core-button/core-button.component';
import { UtilsService } from '@shared/services/utils.service';
import { CurrencyService } from '@shared/services/currency.service';
import { ICurrency } from '@shared/models/currency.model';
import { SessionStorageService } from '@shared/services/session-storage.service';
import { MenuService } from '@shared/services/menu.service';
import { PermissionDirective } from '@shared/directives/permission.directive';

@Component({
  selector: 'app-header',
  imports: [
    NgOptimizedImage,
    MatToolbarModule,
    // MatIcon,
    MatButtonModule,
    CoreDropButtonComponent,
    CoreButtonComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private _authService = inject(AuthService);
  private _currencyService = inject(CurrencyService);
  private _sessionStorageService = inject(SessionStorageService);
  menuService = inject(MenuService);
  currencyList: ICurrency[] = [];
  currentTheme: 'light' | 'dark' = 'light';
  selectedCurrency!: ICurrency;

  userConfigSign = effect(() => {
    if (this._sessionStorageService.userConfigChanged()) {
      let currency = this._sessionStorageService.config.currency;
      if (currency) this.selectedCurrency = currency;
    }
  });

  currencyListSignal = effect(() => {
    this.currencyList = this._currencyService.currencyListSig();
    this.checkCurrencyList();
  });

  @HostListener('window:resize')
  onWindowChange() {
    this.getTheme();
  }

  ngOnInit() {
    this.getTheme();
  }

  ngOnDestroy(): void {
    this.userConfigSign && this.userConfigSign.destroy();
    this.currencyListSignal && this.currencyListSignal.destroy();
  }

  getTheme() {
    const html = document.getElementsByTagName('body')[0];
    let config = this._sessionStorageService.config;
    this.currentTheme = config.theme ?? (html.getAttribute('data-theme') as 'light' | 'dark') ?? 'light';
  }

  changeCurrency(currency: ICurrency) {
    this._currencyService.changeCurrency(currency);
  }

  toggleTheme() {
    const html = document.getElementsByTagName('body')[0];
    const currentTheme = html.getAttribute('data-theme');
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
    this.currentTheme = newTheme;
    let config = this._sessionStorageService.config;
    config.theme = newTheme;
    this._sessionStorageService.setConfig(config);
    this._sessionStorageService.userConfigChanged.set(false);
    this._sessionStorageService.userConfigChanged.set(true);
    html.setAttribute('data-theme', newTheme);
  }

  toggleMenu() {
    this.menuService.toggleMenu();
  }

  private checkCurrencyList() {
    let currency = this._sessionStorageService.config.currency;
    if (currency) {
      this.selectedCurrency = currency;
    }
  }
}
